import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./karir-v2/karir-v2.component').then((c) => c.KarirV2Component),
    children: [
      {
        path: '',
        loadComponent: () => import('./karir-home/karir-home.component').then((c) => c.KarirHomeComponent),
      },
      {
        path: 'hd-squad-life',
        loadComponent: () => import('./hd-squad-life/hd-squad-life.component').then((c) => c.HdSquadLifeComponent),
      },
      {
        path: 'privacy-notice',
        loadComponent: () =>
          import('./career-privacy-notice/career-privacy-notice.component').then((c) => c.CareerPrivacyNoticeComponent),
      },
      {
        path: '**',
        redirectTo: '',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class KarirV2RoutingModule {}
